import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DispositionState } from './disposition.reducer';
import { IListClientsRequest } from '../../models/client.model';

export const selectDispositionState = createFeatureSelector<DispositionState>('disposition');

export const selectAllDispositions = createSelector(
  selectDispositionState,
  (state) => state.dispositions
);

export const selectCurrentDisposition = createSelector(
  selectDispositionState,
  (state) => state.currentDisposition
);

export const selectLoading = createSelector(
  selectDispositionState,
  (state) => state.loading
);

export const selectError = createSelector(
  selectDispositionState,
  (state) => state.error
);

export const selectPagination = createSelector(
  selectDispositionState,
  (state) => state.pagination
);

export const selectSearchCriteria = createSelector(
  selectDispositionState,
  (state) => state.filter
);

export const selectActiveDispositions = createSelector(
  selectAllDispositions,
  (dispositions) => dispositions.filter(loc => loc.is_active)
);

export const selectPaginate = createSelector(selectDispositionState, (state) => {
  return { limit: state.pagination.limit, page: state.pagination.page, total: state.pagination.total };
});

export const getQueries = createSelector(
  selectDispositionState,
  (state) =>
  ({
    params: {
      limit: state.pagination.limit,
      page: state.pagination.page,
    },
    body: {
      filter: state.filter,
      sort: state.sort,
    },
  } as IListClientsRequest)
);

export const selectDispositionNames = createSelector(
  selectDispositionState,
  (state) => state.dispositionNames ?? []
);

export const selectAllStatusDispositionNames = createSelector(
  selectDispositionState,
  (state) => state.allStatusDispositionNames ?? []
);
